import { FaOptionIcon, NamedIconsType } from '@europrocurement/l2d-icons';
import { SizeProp } from '@fortawesome/fontawesome-svg-core';
import { Tooltip, TypographyProps } from '@mui/material';
import * as React from 'react';

export type TooltipedIconProps = {
    tooltip: string | (React.JSX.Element | null)[];
    icon: NamedIconsType;
    size?: SizeProp;
    color?: TypographyProps['color'];
};

export const TooltipedIcon: React.FunctionComponent<TooltipedIconProps> = function ({
    tooltip,
    icon,
    size,
    color,
}) {
    const sizeProp = size ? { size } : {};
    const colorProp = color ? { color } : {};
    const iconTooltip = { ...icon.props, tooltip, ...sizeProp, ...colorProp };
    return (
        <Tooltip title={tooltip}>
            <FaOptionIcon {...iconTooltip} />
        </Tooltip>
    );
};
